import { render, staticRenderFns } from "./releaseDialog.vue?vue&type=template&id=42442648&scoped=true&"
import script from "./releaseDialog.vue?vue&type=script&lang=js&"
export * from "./releaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./releaseDialog.vue?vue&type=style&index=0&id=42442648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42442648",
  null
  
)

export default component.exports